class FeatureCardsDots extends HTMLElement {
  /** @type {HTMLElement | null} */
  _grid = null;

  /** @type {HTMLElement[]} */
  _dots = [];

  /** @type {(() => void)} */
  _boundUpdate = this._update.bind(this);

  connectedCallback() {
    const targetId = this.dataset.target;
    if (!targetId) return;

    this._grid = document.getElementById(targetId);
    this._dots = Array.from(this.querySelectorAll('.feature-cards__dot'));

    if (!this._grid || this._dots.length === 0) return;

    this._grid.addEventListener('scroll', this._boundUpdate, { passive: true });

    this._update();
  }

  disconnectedCallback() {
    if (this._grid) {
      this._grid.removeEventListener('scroll', this._boundUpdate);
    }
  }

  _update() {
    if (!this._grid) return;

    const cards = this._grid.querySelectorAll('.feature-cards__card');
    if (cards.length === 0) return;

    const firstCard = /** @type {HTMLElement} */ (cards[0]);
    // Card width + gap (10px mobile gap defined in CSS)
    const cardStep = firstCard.offsetWidth + 10;
    const scrollLeft = this._grid.scrollLeft;

    // Round to nearest card index
    const activeIndex = Math.min(
      Math.round(scrollLeft / cardStep),
      this._dots.length - 1
    );

    this._dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === activeIndex);
    });
  }
}

customElements.define('feature-cards-dots', FeatureCardsDots);
